import { render, staticRenderFns } from "./ChangeOrder.vue?vue&type=template&id=4f459d6e&scoped=true&"
import script from "./ChangeOrder.vue?vue&type=script&lang=js&"
export * from "./ChangeOrder.vue?vue&type=script&lang=js&"
import style0 from "./ChangeOrder.vue?vue&type=style&index=0&id=4f459d6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f459d6e",
  null
  
)

export default component.exports